import { HStack, Text } from "@chakra-ui/react";
import { forwardRef } from "react";
import { Company } from "../auto-generated-clients/companydata-client-v2.generated";

interface NavigationBarItemProps {
  company: Company;
  selected: boolean;
  onCompanyClick: (company: Company) => void;
}

export const NavigationBarCompanyItem = forwardRef<
  HTMLDivElement,
  NavigationBarItemProps
>(({ company, selected, onCompanyClick }, ref) => {
  return (
    <HStack
      _hover={{
        bg: selected ? "secondary.2" : "secondary.1",
        cursor: "pointer",
      }}
      bg={selected ? "secondary.2" : "secondary.0"}
      width={"100%"}
      px={4}
      py={1.5}
      borderRadius={"lg"}
      flexDirection={"row"}
      fontSize={"sm"}
      onClick={() => onCompanyClick(company)}
      ref={ref}
    >
      <Text
        alignContent={"center"}
        alignItems={"center"}
      >
        {company.friendlyName}
      </Text>
    </HStack>
  );
});
